if (typeof window.printSectionsByDescendantClassSubstring !== "function") {
    window.printSectionsByDescendantClassSubstring = function (needle) {
      if (typeof needle !== "string" || needle.length === 0) {
        window.print();
        return;
      }
  
      // Escape quotes for attribute selectors
      var esc = function (s) { return s.replace(/["\\]/g, "\\$&"); };
  
      // Candidate "sections": semantic <section> + Shopify wrappers
      var sectionCandidates = Array.prototype.slice.call(
        document.querySelectorAll('section, [id^="shopify-section"]')
      );
  
      // Keep sections that contain a DIV with class or id containing the substring
      var selectorWithin =
        'div[class*="' + esc(needle) + '"], div[id*="' + esc(needle) + '"]';
      var keepSections = sectionCandidates.filter(function (sec) {
        return sec.querySelector(selectorWithin) !== null;
      });
  
      if (keepSections.length === 0) {
        window.print();
        return;
      }
  
      // Build a temporary print-only container with clones
      var printContainer = document.createElement("div");
      printContainer.id = "print-container-only-matches";
      keepSections.forEach(function (sec) {
        printContainer.appendChild(sec.cloneNode(true));
      });
      document.body.appendChild(printContainer);
  
      // Inject print CSS (hide all except our container + always hide .print-recipy buttons)
      var style = document.createElement("style");
      style.id = "print-container-style";
      style.textContent = '\
        @media print {\
          .print-recipy, #print-richtext { display: none !important; }\
          body.__printing_filtered > :not(#print-container-only-matches):not(style) {\
            display: none !important;\
          }\
          body.__printing_filtered #print-container-only-matches {\
            display: block !important;\
          }\
        }';
      document.head.appendChild(style);
  
      // Enter "print mode"
      document.body.classList.add("__printing_filtered");
  
      var cleaned = false;
      function cleanup() {
        if (cleaned) return;
        cleaned = true;
        document.body.classList.remove("__printing_filtered");
        if (style && style.parentNode) style.parentNode.removeChild(style);
        if (printContainer && printContainer.parentNode) {
          printContainer.parentNode.removeChild(printContainer);
        }
        window.removeEventListener("afterprint", cleanup);
      }
      window.addEventListener("afterprint", cleanup, { once: true });
      var fallback = setTimeout(cleanup, 1500);
  
      window.addEventListener("afterprint", function () {
        clearTimeout(fallback);
      }, { once: true });
  
      window.print();
    };
  }
  
  (function initPrintRecipy() {
    if (window.__PRINT_RECIPY_INIT__) return; // guard against duplicate init
    window.__PRINT_RECIPY_INIT__ = true;
  
    function bind() {
      document.addEventListener("click", function (e) {
        var target = e.target;
        // Support clicks on child elements inside the button/link
        if (!(target instanceof Element)) return;
        var btn = target.closest(".print-recipy");
        if (!btn) return;
  
        e.preventDefault();
        window.printSectionsByDescendantClassSubstring("__rich_text_");
      });
    }
  
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", bind, { once: true });
    } else {
      bind();
    }
  })();